import InterviewConfiguration from "./InterviewConfiguration.page";

export default InterviewConfiguration;